import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Field,
  ErrorMessage,
  useFormik,
  FormikProvider,
} from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
// @YUp
import * as Yup from "yup";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import API from "../../utils/Axios.utils";
import { Country, State, City } from "country-state-city";
import DeleteIcon from "@mui/icons-material/Delete";
import { Notification } from "../../utils/Notification";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const AddSupplier = () => {
  // const classes = useStyles();
  const classes = {};
  const navigate = useNavigate();

  const fileInputRefs = {
    GST: useRef(null),
    CIN: useRef(null),
    PAN: useRef(null),
  };
  // const [skills, setSkills] = useState([]);
  // const [skillsName, setSkillsName] = useState([]);
  // const [newSkill, setNewSkill] = useState("");
  // const [searchResults, setSearchResults] = useState([]);
  const [files, setFiles] = useState({
    GST: null,
    CIN: null,
    PAN: null,
  });
  const [showPassword, setShowPassword] = useState(false);

  //   Country City State
  const [countries] = useState(Country.getAllCountries());
  const [selectedCountry, setSelectedCountry] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [city, setCity] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  // Snackbar
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [alertType, setAlertType] = useState("");

  // Show Skill
  // const [showSkill, setShowSkill] = useState(false);

  const handleAlert = () => {
    setAlert(false);
  };

  // Add and remove skills
  // const handleAddSkills = (selectedSkill) => {
  //   if (selectedSkill.trim() !== "") {
  //     if (skills.some((skill) => skill.name === selectedSkill)) {
  //       setAlertContent("Skill already exists");
  //       setAlertType("error");
  //       setAlert(true);
  //     } else {
  //       const newSkillObject = {
  //         id: Date.now(),
  //         name: selectedSkill,
  //       };

  //       setSkills([...skills, newSkillObject]);
  //     }

  //     // Reset the input field after adding
  //     setNewSkill("");
  //   }
  // };

  // const handleRemoveSkill = (id) => {
  //   const updatedSkills = skills.filter((skill) => skill.id !== id);
  //   setSkills(updatedSkills);
  // };

  //   Add and Remove Files
  const handleFileChange = (event, docType) => {
    const selectedFile = event.target.files[0];

    setFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: selectedFile,
    }));
  };

  const handleRemoveFile = (docType) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: null,
    }));
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "Minimum 2 characters are required.")
      .max(50, "Maximum length is 50 characters.")
      .matches(/^[A-Za-z\s]+$/, "Only alphabetic characters and spaces are allowed.")
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed.",
        (value) => value === value?.trim()
      )
      .required("This field is required."),
    last_name: Yup.string()
      .min(2, "Minimum 2 characters are required.")
      .max(50, "Maximum length is 50 characters.")
      .matches(/^[A-Za-z\s]+$/, "Only alphabetic characters and spaces are allowed.")
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed.",
        (value) => value === value?.trim()
      )
      .required("This field is required."),
    email: Yup.string()
      .email("Email must be a valid email address.")
      .trim()
      .matches(
        /^[\w-.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
        "Email must be a valid email address."
      )
      .max(120, "Email must be at most 120 characters long.") // Limit email length to 254 characters
      .required("Email is required."),

    password: Yup.string()
      .required("This field is required.")
      .min(8, "Password must be at least 8 characters")
      .max(20, "Password must be at most 20 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      ),
    mobile: Yup.string()
      .required("This field is required.")
      .matches(
        /^\+91[6-9]\d{9}$/,
        "Please enter a valid 13-digit number starting with +91 and followed by 10 digits."
      ),
    // supplier_code: Yup.string()
    //   .required("This field is required.")
    //   .min(8, "Minimum 8 caharacter is required.")
    //   .max(8, "Maximum 8 caharacter is required.")
    //   .matches(/^\S.*\S$/, "Spaces at the start and end are not allowed."),
    supplier_org_name: Yup.string()
      .required("This field is required.")
      .min(1, "Minimum 1 caharacter is required.")
      .max(50, "Maximum length is 50 characters."),
    business_address: Yup.string()
      .required("This field is required.")
      .min(1, "Minimum 1 caharacter is required.")
      .max(1000, "Maximum length is 1000 characters.")
      .matches(/^[^\s].*$/, "Address should not start with a space."),
    pincode: Yup.string()
      .required("This field is required.")
      .matches(/^[0-9]{6}$/, "Zip Code must be exactly 6 digits."),
    city: Yup.string().required("This field is required."),
    state: Yup.string().required("This field is required."),
    country: Yup.string().required("This field is required."),
    is_preffered_supplier: Yup.string().required("This field is required."),
    referred_by: Yup.string().required("This field is required."),
    supplier_additional_email: Yup.string()
      .email("Email must be a valid email address.")
      .trim()
      .matches(
        /^[\w-.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
        "Email must be a valid email address."
      )
      .max(120, "Email must be at most 120 characters long.") // Limit email length to 254 characters
      .required("Email is required."),
    gst_number: Yup.string()
      .trim()
      .required("GST number is required")
      .matches(
        /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/,
        "Invalid GST number"
      ),
    pan_number: Yup.string()
      .required("PAN number is required")
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number format"),
    CIN: Yup.string()
      .matches(
        /^[A-Z]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/,
        "Please enter a valid CIN."
      )
      .required("CIN is required"),
    coreSkillIds: Yup.array().min(1, "At least one core skill is required").required("Core skills are required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      // supplier_code: "",
      supplier_org_name: "",
      business_address: "",
      pincode: "",
      city: "",
      state: "",
      country: "",
      is_preffered_supplier: "Y",
      candidate_submission_email_enabled: "Y",
      referred_by: "",
      supplier_additional_email: "",
      gst_number: "",
      pan_number: "",
      CIN: "",
      coreSkillIds: []
    },
    validationSchema: validationSchema,
    onSubmit: async () => {
      await onSubmit(formik);
    },
  });

  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const onSubmit = async (formik) => {
    if (
      // skills.length === 0 ||
      files.GST == null ||
      files.CIN == null ||
      files.PAN == null
    ) {
      setIsFormSubmitted(true);
    } else {
      try {
        const formData = new FormData();
        formData.append("first_name", formik.values.first_name);
        formData.append("last_name", formik.values.last_name);
        formData.append("email", formik.values.email);
        formData.append("password", formik.values.password);
        formData.append("mobile", formik.values.mobile);
        formData.append("org_name", "sty");
        // formData.append("supplier_code", values.supplier_code);
        formData.append("supplier_org_name", formik.values.supplier_org_name);
        formData.append("business_address", formik.values.business_address);
        formData.append("pincode", formik.values.pincode);
        formData.append("city", formik.values.city);
        formData.append("state", formik.values.state);
        formData.append("country", formik.values.country);
        formData.append(
          "is_preffered_supplier",
          formik.values.is_preffered_supplier
        );
        formData.append(
          "candidate_submission_email_enabled",
          formik.values.candidate_submission_email_enabled
        );
        formData.append("referred_by", formik.values.referred_by);
        formData.append(
          "supplier_additional_email",
          formik.values.supplier_additional_email
        );
        formData.append("gst_number", formik.values.gst_number);
        formData.append("pan_number", formik.values.pan_number);
        formData.append("CIN", formik.values.CIN);
        // formData.append("skills", skillsName);
        formData.append("gst_doc", files.GST);
        formData.append("pan_doc", files.PAN);
        formData.append("CIN_doc", files.CIN);
        formData.append("coreSkillIds", JSON.stringify(formik.values.coreSkillIds));
        const res = await API.post("/api/users/register", formData, config);
        setIsFormSubmitted(false);
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
        setTimeout(() => {
          navigate("/suppliermanagement");
        }, 1500);
      } catch (error) {
        setIsFormSubmitted(false);
        setAlertContent(error.response.data.message);
        setAlertType("error");
        setAlert(true);
      }
    }
  };

  // const debouncedQueryList = useDebounce(newSkill, 500);

  // const handleSearchSkills = async () => {
  //   if (newSkill !== "") {
  //     let url = `/api/skill/skill_list?search=${debouncedQueryList}`;
  //     try {
  //       const res = await API.get(url, config);
  //       setSearchResults(res?.data?.skill);
  //     } catch (error) {
  //       setAlertContent(error?.response?.data?.message);
  //       setAlertType("error");
  //       setAlert(true);
  //     }
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  const [coreSkills, setCoreSkills] = useState([]);

  useEffect(() => {
    const fetchCoreSkills = async () => {
      try {
        const res = await API.get("/api/core-skill/coreSkills", config);
        const formattedCore = res?.data?.coreSkills?.map(item => ({
          id: item.id,
          value: item.id,
          label: item.name,
        }));
        setCoreSkills(formattedCore);
      } catch (error) {
        setAlertContent(error?.response?.data?.message || "Failed to load core skills");
        setAlertType("error");
        setAlert(true);
      }
    };
    fetchCoreSkills();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  // useEffect(() => {
  //   handleSearchSkills();
  // }, [debouncedQueryList]);

  useEffect(() => {
    if (selectedCountry) {
      setState(State.getStatesOfCountry(selectedCountry.isoCode));
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedState) {
      setCity(
        City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode)
      );
    }
  }, [selectedState]);

  // useEffect(() => {
  //   const skillsNames = skills.map((skill) => skill.name);
  //   setSkillsName(skillsNames);
  // }, [skills]);
  const {
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    getFieldProps,
  } = formik;

  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "20px",
            fontWeight: "500",
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          <span>Create Supplier</span>
          <div style={{ display: "grid" }}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>First Name <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="first_name"
                      autoComplete="first_name"
                      fullWidth
                      {...getFieldProps("first_name")}
                      error={Boolean(touched.first_name && errors.first_name)}
                      helperText={touched.first_name && errors.first_name}
                      size="small"
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Last Name <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="last_name"
                      fullWidth
                      {...getFieldProps("last_name")}
                      error={Boolean(touched.last_name && errors.last_name)}
                      helperText={touched.last_name && errors.last_name}
                      size="small"
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Phone Number <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="mobile"
                      fullWidth
                      {...getFieldProps("mobile")}
                      error={Boolean(touched.mobile && errors.mobile)}
                      helperText={touched.mobile && errors.mobile}
                      size="small"
                      required
                    />
                  </Grid>
                  {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Supplier Code</span>
                      <Field
                        as={TextField}
                        name="supplier_code"
                        fullWidth
                        error={
                          props.errors.supplier_code &&
                          props.touched.supplier_code
                        }
                        size="small"
                        helperText={<ErrorMessage name="supplier_code" />}
                        required
                      />
                    </Grid> */}
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>
                      Supplier Organisation Name <span style={{ color: "red" }}>*</span>
                    </span>
                    <Field
                      as={TextField}
                      name="supplier_org_name"
                      fullWidth
                      {...getFieldProps("supplier_org_name")}
                      error={Boolean(
                        touched.supplier_org_name && errors.supplier_org_name
                      )}
                      helperText={
                        touched.supplier_org_name && errors.supplier_org_name
                      }
                      size="small"
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Zip Code <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="pincode"
                      fullWidth
                      {...getFieldProps("pincode")}
                      error={Boolean(touched.pincode && errors.pincode)}
                      helperText={touched.pincode && errors.pincode}
                      size="small"
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      {...getFieldProps("country")}
                      error={Boolean(touched.country && errors.country)}
                      className={classes.input_root}
                    >
                      <Field
                        as={Select}
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: 200, width: 100 } },
                        }}
                        name="country"
                        id="select"
                        variant="outlined"
                        {...getFieldProps("country")}
                        placeholder="Select country"
                        error={Boolean(touched.country && errors.country)}
                        size="small"
                        required
                        className={classes.input_root}
                        displayEmpty
                      >
                        {countries.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.name}
                            onClick={() => setSelectedCountry(item)}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText sx={{ color: "red" }}>
                        {touched && touched.country && errors && errors.country}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>State <span style={{ color: "red" }}>*</span></span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={Boolean(
                        touched && touched.state && errors && errors.state
                      )}
                    >
                      <Field
                        as={Select}
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: 200, width: 100 } },
                        }}
                        name="state"
                        id="select"
                        variant="outlined"
                        placeholder="Select state"
                        {...getFieldProps("state")}
                        error={Boolean(
                          touched && touched.state && errors && errors.state
                        )}
                        size="small"
                        required
                        className={classes.input_root}
                        displayEmpty
                      >
                        {state.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.name}
                            onClick={() => setSelectedState(item)}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText sx={{ color: "red" }}>
                        {touched && touched.state && errors && errors.state}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>City <span style={{ color: "red" }}>*</span></span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={Boolean(
                        touched && touched.city && errors && errors.city
                      )}
                      className={classes.input_root}
                    >
                      <Field
                        as={Select}
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: 200, width: 100 } },
                        }}
                        name="city"
                        id="select"
                        variant="outlined"
                        placeholder="Select City"
                        {...getFieldProps("city")}
                        error={Boolean(
                          touched && touched.city && errors && errors.city
                        )}
                        size="small"
                        required
                        className={classes.input_root}
                        displayEmpty
                      >
                        {city.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText sx={{ color: "red" }}>
                        {touched && touched.city && errors && errors.city}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Preferred Supplier <span style={{ color: "red" }}>*</span></span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={Boolean(
                        touched &&
                        touched.is_preffered_supplier &&
                        errors &&
                        errors.is_preffered_supplier
                      )}
                    >
                      <Field
                        as={Select}
                        name="is_preffered_supplier"
                        id="select"
                        variant="outlined"
                        {...getFieldProps("is_preffered_supplier")}
                        error={Boolean(
                          touched &&
                          touched.is_preffered_supplier &&
                          errors &&
                          errors.is_preffered_supplier
                        )}
                        size="small"
                        required
                        displayEmpty
                      >
                        {PreferredSupplier.map((name) => {
                          return (
                            <MenuItem key={name.id} value={name.pref}>
                              {name.prefName}
                            </MenuItem>
                          );
                        })}
                      </Field>
                      <FormHelperText sx={{ color: "red" }}>
                        {touched &&
                          touched.is_preffered_supplier &&
                          errors &&
                          errors.is_preffered_supplier}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Candidate Submission Email (ACX)</span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                    >
                      <Field
                        as={Select}
                        name="candidate_submission_email_enabled"
                        id="select"
                        variant="outlined"
                        {...getFieldProps("candidate_submission_email_enabled")}
                        size="small"
                        displayEmpty
                      >
                        {PreferredSupplier.map((name) => {
                          return (
                            <MenuItem key={name.id} value={name.pref}>
                              {name.prefName}
                            </MenuItem>
                          );
                        })}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Referred By <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="referred_by"
                      fullWidth
                      {...getFieldProps("referred_by")}
                      error={errors.referred_by && touched.referred_by}
                      size="small"
                      helperText={<ErrorMessage name="referred_by" />}
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Additional Email <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="supplier_additional_email"
                      fullWidth
                      {...getFieldProps("supplier_additional_email")}
                      error={
                        errors.supplier_additional_email &&
                        touched.supplier_additional_email
                      }
                      size="small"
                      helperText={
                        <ErrorMessage name="supplier_additional_email" />
                      }
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>GST Number <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="gst_number"
                      fullWidth
                      {...getFieldProps("gst_number")}
                      error={errors.gst_number && touched.gst_number}
                      size="small"
                      helperText={<ErrorMessage name="gst_number" />}
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>PAN Number <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="pan_number"
                      fullWidth
                      {...getFieldProps("pan_number")}
                      error={errors.pan_number && touched.pan_number}
                      size="small"
                      helperText={<ErrorMessage name="pan_number" />}
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>CIN <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="CIN"
                      fullWidth
                      {...getFieldProps("CIN")}
                      error={errors.CIN && touched.CIN}
                      size="small"
                      helperText={<ErrorMessage name="CIN" />}
                      required
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Email <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      fullWidth
                      autoComplete="username"
                      name="email"
                      type="email"
                      {...getFieldProps("email")}
                      size="small"
                      style={{ marginBottom: "8%" }}
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Password <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="password"
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      {...getFieldProps("password")}
                      error={errors.password && touched.password}
                      size="small"
                      helperText={<ErrorMessage name="password" />}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={() => {
                                setShowPassword((show) => !show);
                              }}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
                  <Grid item xl={8} lg={8} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Business Address <span style={{ color: "red" }}>*</span></span>
                    <Field
                      as={TextField}
                      name="business_address"
                      multiline
                      rows={5}
                      fullWidth
                      {...getFieldProps("business_address")}
                      error={
                        errors.business_address && touched.business_address
                      }
                      size="small"
                      helperText={<ErrorMessage name="business_address" />}
                      required
                    />
                  </Grid>
                  {/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Core Skill</span>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={Boolean(formik.touched.coreSkillIds && formik.errors.coreSkillIds)}
                    >
                      <Field
                        as={Select}
                        name="coreSkillIds"
                        displayEmpty
                        onChange={e => formik.setFieldValue("coreSkillIds", e.target.value)}
                        value={formik.values.coreSkillIds}
                        size="small"
                        variant="outlined"
                      >
                        <MenuItem value="">
                          <em>Select Core Skill</em>
                        </MenuItem>
                        {coreSkills.map(option => (
                          <MenuItem key={option.id} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText sx={{ color: "red" }}>
                        <ErrorMessage name="coreSkillIds" />
                      </FormHelperText>
                    </FormControl>
                  </Grid> */}
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <span style={{ fontSize: '16px' }}>Core Skills <span style={{ color: 'red' }}>*</span></span>
                    <FormControl fullWidth variant="outlined" size="small" error={formik.touched.coreSkillIds && Boolean(formik.errors.coreSkillIds)}>
                      <Field as={Select}
                        multiple
                        name="coreSkillIds"
                        value={formik.values.coreSkillIds}
                        onChange={(e) => {
                          formik.setFieldValue('coreSkillIds', e.target.value);
                        }}
                        displayEmpty
                        MenuProps={{
                          PaperProps: {
                            sx: { maxHeight: 200 }
                          }
                        }}
                        variant="outlined"
                        size="small"
                        className={classes.inputroot}
                      >
                        <MenuItem value="" disabled>Select Core Skills</MenuItem>
                        {coreSkills.map((option) => (
                          <MenuItem key={option.id} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText sx={{ color: 'red' }}>
                        {formik.touched.coreSkillIds && formik.errors.coreSkillIds}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Skills */}
                  {/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <span style={{ fontSize: "16px" }}>Skills</span>

                    <Grid container style={{ marginBottom: "10px" }}>
                      <Grid
                        item
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {skills.map((skill) => (
                          <div
                            style={{
                              display: "flex",
                              background: "#2777AA",
                              paddingLeft: "0.8rem",
                              paddingRight: "0.8rem",
                              paddingTop: ".2rem",
                              paddingBottom: ".2rem",
                              gap: "10px",
                              color: "white",
                              borderRadius: "1.99rem",
                            }}
                            key={skill.id}
                          >
                            <div style={{ fontSize: "18px" }}>{skill.name}</div>
                            <span
                              style={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() => handleRemoveSkill(skill.id)}
                            >
                              X
                            </span>
                          </div>
                        ))}
                      </Grid>
                    </Grid>

                    <TextField
                      fullWidth
                      size="small"
                      autoComplete="none"
                      value={newSkill}
                      onChange={(e) => {
                        setNewSkill(e.target.value);
                        setShowSkill(true);
                      }}
                    // style={{ paddingBottom: "15px" }}
                    />
                    {isFormSubmitted && skills.length === 0 && (
                      <div
                        style={{
                          color: "#d32f2f",
                          marginLeft: "14px",
                          fontWeight: 400,
                          fontSize: "0.75rem",
                        }}
                      >
                        This Field is required
                      </div>
                    )}

                    {/* searchResults 
                    {/* Display search results 
                    {searchResults.length > 0 && showSkill
                      ? searchResults.map((result) => (
                        <div
                          key={result.skill_id}
                          style={{
                            display: "flex",
                            paddingLeft: "0.8rem",
                            paddingRight: "0.8rem",
                            paddingTop: ".2rem",
                            paddingBottom: ".2rem",
                            gap: "10px",
                            border: "1px solid #c5c2c2",
                            borderRadius: "0.15rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleAddSkills(result.skill_name);
                            setShowSkill(false);
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>
                            {result.skill_name}
                          </div>
                        </div>
                      ))
                      : null}
                    {/* </div> */}

                  {/* <Button
                      variant="contained"
                      aria-haspopup="true"
                      onClick={handleAddSkills}
                      style={{
                        background: "#2777AA",
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",                        fontSize: "18px",
                        fontWeight: "500",
                        letterSpacing: 1,
                        textAlign: "left",
                      }}
                    >
                      <span style={{ fontSize: "22px" }}>+</span>
                      Add Skills
                    </Button> 
                  </Grid> */}
                  {/* File Upload */}
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div
                      style={{
                        marginTop: 20,
                        border: "1px solid #989898",
                        borderRadius: "10px",
                        padding: "15px",
                      }}
                    >
                      <Grid container>
                        {Object.entries(files).map(([docType, file], index) => (
                          <Grid container spacing={2} key={index}>
                            {/* 1st Column */}
                            <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                              {`${docType} Document`} <span style={{ color: "red" }}>*</span>
                            </Grid>

                            {/* 2nd Column */}
                            <Grid
                              item
                              xl={6}
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              display="flex"
                              alignItems="center"
                            >
                              {file && (
                                <>
                                  <div>{file.name}</div>
                                  <DeleteIcon
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                    onClick={() => handleRemoveFile(docType)}
                                  />
                                </>
                              )}
                            </Grid>

                            {/* 3rd Column */}
                            <Grid
                              item
                              xl={3}
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              display="flex"
                              justifyContent="flex-end"
                            >
                              <Button
                                onClick={() =>
                                  fileInputRefs[docType].current.click()
                                }
                              >
                                Browse
                              </Button>
                              <input
                                type="file"
                                hidden="true"
                                onChange={(e) => handleFileChange(e, docType)}
                                ref={fileInputRefs[docType]}
                              />
                            </Grid>
                            {isFormSubmitted && files[docType] == null && (
                              <div
                                style={{
                                  color: "#d32f2f",
                                  marginLeft: "2rem",
                                  fontWeight: 400,
                                  fontSize: "0.75rem",
                                }}
                              >
                                This Field is required
                              </div>
                            )}
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  </Grid>
                  {/* Submit */}
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        aria-haspopup="true"
                        style={{
                          background: (formik.isValid && formik.dirty && files.GST && files.CIN && files.PAN) ? "#2777AA" : "#989898",
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                          fontSize: "16px",
                          fontWeight: "500",
                          letterSpacing: 1,
                        }}
                        type="submit"
                        disabled={!formik.isValid || !formik.dirty || !files.GST || !files.CIN || !files.PAN || isSubmitting}
                      >
                        Submit
                      </Button>
                    </div>
                  </Grid>
                </Grid>
                <Notification
                  message={alertContent}
                  open={alert}
                  severity={alertType}
                  onClose={handleAlert}
                />
              </Form>
            </FormikProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSupplier;

const PreferredSupplier = [
  { id: 1, pref: "Y", prefName: "Yes" },
  { id: 2, pref: "N", prefName: "No" },
];
